import {useSignal} from "@preact/signals-react";
import {useCallback, useEffect} from "react";
import {isEmpty} from "@ui-seeker/utils";

import {matcherSKUImageComparatorModalData} from "../@signals";
import {BACKEND_APIS} from "../../../../@constants";


export default function useImageComparisonNavigation(brandOptions=[], setSelectedSKU) {
	const numOptions = brandOptions?.length
	const isOpen = !isEmpty(matcherSKUImageComparatorModalData.value)

	const localIndex = useSignal(
		Number.isInteger(matcherSKUImageComparatorModalData.value?.targetIndex)
			? matcherSKUImageComparatorModalData.value?.targetIndex
			: 0
	)

	const handleChangeModalData = idx => {
		const option = brandOptions[idx]
		if (option) {
			setSelectedSKU(option.skuID)
			matcherSKUImageComparatorModalData.value = {
				...matcherSKUImageComparatorModalData.value,
				targetIndex: idx,
				title: option.sku,
				fullUrlRight: `${BACKEND_APIS.BACKEND}/sku/image/${option.skuID}`,
			}
		}
	}

	useEffect(() => {
		if (!isOpen)
			return

		const idx = Number.isInteger(matcherSKUImageComparatorModalData.value?.targetIndex)
			? matcherSKUImageComparatorModalData.value?.targetIndex
			: 0

		localIndex.value = idx;
		handleChangeModalData(idx)
	}, [isOpen, matcherSKUImageComparatorModalData.value?.targetIndex]);

	const handleNavigate = useCallback((delta) => {
		if (!numOptions)
			return

		const max = numOptions - 1
		const next = Math.min(Math.max((localIndex.value ?? 0) + delta, 0), max)
		if (next === localIndex.value)
			return
		handleChangeModalData(next)
	}, [numOptions])

	return {
		isOpen,
		numOptions,
		localIndex: localIndex.value,

		handleNavigate,
		handleNavigateLeft: () => handleNavigate(-1),
		handleNavigateRight: () => handleNavigate(1),
	}
}